<template>
    <div v-if="list.length>0" style="background: #f3f3f3; padding: 50px 0 0">
      <div class="warp"  style="display:flex;justify-content:flex-start;align-items:flex-start;">
        <div class="title" style="width:20%;">
          <img
            class="titleImg"
            :src="require(`@/assets/images/b2c/kabi_quanyi.png`)"
            alt=""
            srcset=""
          />
        </div>
        <div class="shopList" style="width:80%;">
          <div class="item" v-for="(item, index) in list" :key="index" @click="toProductDetail(item)">
            <div class="itemImg">
              <img :src="item.image" alt="" srcset="" />
            </div>
            <div class="itemText">
              <div class="itemTitleName">{{ item.productName }}</div>
              <!-- <div class="shopName">
                  <img class="shopImg" style="width:30px;height:30px;" src="../../../assets/images/b2c/kabi_icon.png" alt="" srcset="" />
                  <span class="shopNameText">{{ item.shopName }}</span>
              </div> -->
              <div style="display:flex;justify-content:flex-start;align-items:center;">
                <div class="itemTitlePrice">
                  ￥{{ Number(item.price).toFixed(2) }}   
                </div>
                <s v-if="item.originalPrice" class="itemTitlePrice2">
                  原价:￥{{ Number(item.originalPrice).toFixed(2) }}
                </s>
              </div>
              <div class="payBtn">
                  <img class="shan" src="../../../assets/images/b2c/shan_icon.png" alt="" srcset="">
                  <div class="btn1">销量 100+</div>
                  <div class="btn2">立即兑换</div>
              </div>
              <div class="shopName">
                <img class="shopImg" :src="item.shopLogo" alt="" srcset="" />
                <span class="shopNameText">{{ item.shopName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
    <script>
  import { listSearchMixin } from "../../../config/mixin";
  import api from "@/api_b2c";
  export default {
    name: "tuijian",
    mixins: [listSearchMixin],
    data() {
      return {
        list: [],
      };
    },
    mounted() {
      this.getShopList();
    },
    methods: {
      getShopList() {
        let self = this;
        let _url = api.getIndexCredit + `?page=1&pageSize=5`;
        let params = {
          url: _url,
          method: "GET",
          data: {},
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            this.list = res.data.list;
          } else {
            self.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      },
      toProductDetail(item) {
      let data = {
        productId: item.productId,
        skuId: item.skuId,
        shopId: item.shopId,
      };
      if (item.classifyType == 1) {
          this.$router.push({
          path: "/shop_mall/productDetail_serv",
          query: {
            proData: JSON.stringify(data),
          },
        });
      } else {
          this.$router.push({
          path: "/shop_mall/productDetail",
          query: {
            proData: JSON.stringify(data),
          },
        });
      }
      
    },
    },
  };
  </script>
    
    <style  lang="scss" scoped>
  .shopList {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    background: #ffffff;
    border-radius: 14px;
    .item {
      width: 20%;
      height: 443px;
      background: #fff;
      border: 1px solid #fff;
      &:hover {
        cursor: pointer;
      }
      .shopName {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 10px;
        .shopImg {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
        .shopNameText {
          font-family: PingFang SC;
          font-size: 14px;
          color: #000;
          font-weight: 400;
          margin-left: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .payBtn{
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 200px;
          height: 30px;
          position: relative;
          border-radius: 10px;
          margin: 30px 0 30px 15px;
          .shan{
              width: 20px;
              height: 30px;
              position: absolute;
              left:90px;
              top: 0;
          }
          .btn1{
              font-size: 14px;
              color: #fff;
              font-family: PingFang SC;
              background: #CEA86B;
              width: 100px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 5px 0 0 5px;
          }
          .btn2{
              font-size: 14px;
              color: #E5BDA5;
              font-family: PingFang SC;
              width: 100px;
              height: 30px;
              line-height: 30px;
              background: #2F2316;
              text-align: center;
              border-radius: 0 5px 5px 0;
          }
      }
      .itemImg {
        width: 200px;
        height: 200px;
  
        img {
          width: 200px;
          height: 200px;
          object-fit: cover;
        }
      }
      .itemText {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding: 10px 0;
      }
      .itemTitleName {
        font-family: PingFang SC;
        font-size: 18px;
        color: #000;
        font-weight: bold;
        margin: 10px 0;
        padding: 0 10px;
        height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .itemTitlePrice {
        font-size: 18px;
        color: #ea332f;
        font-weight: bold;
        font-family: PingFang SC;
        padding: 0 10px;
      }
    }
  }
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    background-color: #fff;
    .titleImg {
      width:100%;
    }
    .titleName {
      font-size: 28px;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/b2c/index/quanyi.vue